import React, { FC } from 'react';
// import { IoPersonCircleOutline } from "react-icons/io5";
import transferIcon from '../../../assets/transfer.svg';
import { IoPersonRemoveOutline } from 'react-icons/io5';
import { twMerge } from 'tailwind-merge';

interface ActionMenuProps {
  onClickTransferFounds: () => void;
  onClickRemoveFriend: () => void;
}
const ActionMenu: FC<ActionMenuProps> = ({ onClickTransferFounds, onClickRemoveFriend }) => {
  return (
    <div className={twMerge('w-44 rounded-[10px] bg-phenom-border-glow p-[1px]')}>
      <div className={twMerge('h-full w-full rounded-[10px] bg-ph-background-dark px-4 py-4')}>
        <div className="flex flex-col gap-2">
          {/*  TODO: we will be handle this with player notes*/}
          {/*<div className="flex gap-2">*/}
          {/*  <IoPersonCircleOutline />*/}
          {/*  <span className="font-semibold	text-white text-opacity-50">*/}
          {/*    View Profile*/}
          {/*  </span>*/}
          {/*</div>*/}
          <div className="flex cursor-pointer items-center gap-2" onClick={onClickTransferFounds}>
            <img src={transferIcon} alt="transferIcon" className="h-5 w-5" />
            <span className="text-sm font-semibold text-white text-opacity-50">Transfer Funds</span>
          </div>
          <div className="flex cursor-pointer items-center gap-2" onClick={onClickRemoveFriend}>
            <IoPersonRemoveOutline className="h-5 w-5 !text-white !text-opacity-50" />
            <span className="text-sm font-semibold text-white text-opacity-50">Remove</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionMenu;
